import type { ThemeConfig } from 'antd';
import { theme } from 'antd';
import type { ColorMode } from '@/core/auth/uiStore';

export const createThemeConfig = (mode: ColorMode): ThemeConfig => ({
  algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
  token: {
    colorPrimary: '#155eef',
    colorInfo: '#155eef',
    colorSuccess: '#12b76a',
    colorWarning: '#f79009',
    colorError: '#f04438',
    borderRadius: 10,
    borderRadiusLG: 16,
    fontFamily:
      'Shabnam, Tahoma, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  components: {
    Layout: {
      headerBg: mode === 'dark' ? '#111827' : '#ffffff',
      siderBg: mode === 'dark' ? '#101828' : '#ffffff',
      bodyBg: mode === 'dark' ? '#0b1220' : '#f5f7fb',
    },
    Menu: {
      itemBorderRadius: 10,
      itemMarginInline: 10,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Table: {
      headerBg: mode === 'dark' ? '#1f2937' : '#f8fafc',
      headerColor: mode === 'dark' ? '#f9fafb' : '#344054',
    },
  },
});
